import "./Keyboard.scss";
interface KeyboardProps extends React.HTMLAttributes<HTMLDivElement> {
  onClickArrow: (e: string) => void;
}
const KeyboardArrows: React.FC<KeyboardProps> = ({ onClickArrow }) => {
  return (
    <div className="keyboard-arrows">
      <div className="keyboard-arrows__comment">
        <span>{"// use keyboard"}</span>
        <span>{"// arrows to play"}</span>
      </div>
      <div className="keyboard-arrows__arrows">
        <div
          className="keyboard-arrows__arrow-top"
          onClick={() => onClickArrow("top")}
        >
          <svg
            width="9"
            height="7"
            viewBox="0 0 9 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.50002 0.309143L8.75003 6.30914H0.25L4.50002 0.309143Z"
              fill="white"
            />
          </svg>
        </div>
        <div className="keyboard-arrows__arrows-line">
          <span onClick={() => onClickArrow("left")}>
            <svg
              width="7"
              height="10"
              viewBox="0 0 7 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.0390623 4.80914L6.03906 0.559128L6.03906 9.05916L0.0390623 4.80914Z"
                fill="white"
              />
            </svg>
          </span>
          <span onClick={() => onClickArrow("bottom")}>
            <svg
              width="9"
              height="7"
              viewBox="0 0 9 7"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.49998 6.80914L0.24997 0.809142L8.75 0.809143L4.49998 6.80914Z"
                fill="white"
              />
            </svg>
          </span>
          <span onClick={() => onClickArrow("right")}>
            <svg
              width="7"
              height="10"
              viewBox="0 0 7 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.96094 4.80914L0.960938 9.05916L0.960938 0.559128L6.96094 4.80914Z"
                fill="white"
              />
            </svg>
          </span>
        </div>
      </div>
    </div>
  );
};
export default KeyboardArrows;
